// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"b2eb31b6","764":"581127c3","770":"b2eb31b6"}[chunkId] + ".chunk.css";
};